import { Check, ChevronDown, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useLanguage, type Language } from "@/components/language-provider";

// Each language is named in its own language; the current one shows a check instead of its code.
const OPTIONS: { code: Language; label: string }[] = [
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
];

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-1.5"
          aria-label="Language / Idioma"
          data-testid="button-language-toggle"
        >
          <Globe className="h-4 w-4" />
          <span className="text-xs font-medium">{language.toUpperCase()}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[11rem]">
        {OPTIONS.map((o) => (
          <DropdownMenuItem
            key={o.code}
            onSelect={() => setLanguage(o.code)}
            className="flex items-center justify-between gap-6"
            data-testid={`language-option-${o.code}`}
          >
            <span lang={o.code === "pt" ? "pt-BR" : o.code}>{o.label}</span>
            {language === o.code
              ? <Check className="h-4 w-4" aria-label="✓" />
              : <span className="text-xs text-muted-foreground">{o.code.toUpperCase()}</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
